import { Trans } from 'react-i18next';
import { LinkText } from '~/components/common/buttons/LinkText';

type HtmlInterpolation = {
  key: string;
  path: string;
};

type HTMLTransProps = {
  translationKey: string;
  values: Object;
  HtmlInterpolations: HtmlInterpolation[];
};

const HtmlTrans = ({ translationKey, values, HtmlInterpolations }: HTMLTransProps) => {
  const components: { [key: string]: JSX.Element } = {};
  HtmlInterpolations.forEach((link) => {
    components[link.key] = (
      <LinkText
        variant="primary"
        extraClasses="-link-small"
        to={link.path}
        target="_blank"
      />
    );
  });

  return (
    <Trans
      i18nKey={translationKey}
      shouldUnescape={true}
      values={values}
      components={components}
    />
  );
};

export default HtmlTrans;
